export default __webpack_public_path__ + "static/media/french.1e5f0c52.png";